// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__tyW7t","notes":"Notes_notes__3pRMs"};